import { Box, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Icons } from '../../../utils/utilities'
import api from '../../../service/api'
import { exportDiscussionsAuditReport } from '../../../utils/auditing-export-utilities'
import DataLoadingSpinner from '../../common/DataLoadingSpinner'
import TryAgainMessageBlock from '../../common/TryAgainMessageBlock'
import AuditPageStatsFilterBar from '../AuditPageStatsFilterBar'
import CustomTable from '../../common/custom-table/CustomTable'


const DiscussionsStats = () => {

    const [searchParams] = useSearchParams( { sortByCommentsCount: "0", sortByVotesCount: "0", searchText: "", month: "", selectedInstitute: "all", view: "tabular", sortByName: "1", sortByViewsCount: "0", sortByDiscussionsCount: "0" } )
    const month = searchParams.get( 'month' ) || ""
    const selectedInstitute = searchParams.get( 'selectedInstitute' ) || "all"

    const [loading, setLoading] = useState( true )
    const [userStats, setUserStats] = useState( [] )
    const [statsError, setStatsError] = useState( null )
    const [last12MonthsStats, setLast12MonthsStats] = useState( [] )

    const { layout } = useTheme()

    const columns = [
        { id: 1, field: "index", index: true, name: 'Sl.No.', width: "50px", align: "center", padding: "10px 20px" },
        { id: 2, field: "name", filterable: true, linkGetter: row => row?._id?.role !== 'STUDENT' ? `/${window.location.pathname?.includes( 'admin' ) ? "admin" : "audit"}/faculty/${row._id.created_by}?legacy=${row._id?.legacy_system_data}` : "", renderCell: row => row?._id?.name?.toLowerCase() || row?._id.created_by, cellStyles: { textTransform: "capitalize" }, name: "Posted by", width: "150px", padding: "10px 20px" },
        { id: 3, field: "created_by", filterable: true, linkGetter: row => row?._id?.role !== 'STUDENT' ? `/${window.location.pathname?.includes( 'admin' ) ? "admin" : "audit"}/faculty/${row._id.created_by}?legacy=${row._id?.legacy_system_data}` : "", renderCell: row => row._id.created_by, name: 'AUID', padding: "10px 20px" },
        { id: 6, field: "institute", filterable: true, renderCell: row => row?._id?.institute, name: 'institute', padding: "10px 20px" },
        { id: 4, field: "count", sortable: true, align: "center", style: { align: "center" }, name: "Discussions", width: "150px", padding: "10px 20px" },
        { id: 5, field: "views", sortable: true, align: "center", style: { align: "center" }, name: "Views", width: "150px", padding: "10px 20px" },
        { id: 7, field: "comments", sortable: true, align: "center", style: { align: "center" }, name: "Comments", width: "150px", padding: "10px 20px" },
        { id: 8, field: "votes", sortable: true, align: "center", style: { align: "center" }, name: "Votes(up - down)", width: "150px", padding: "10px 20px" },
    ]


    const getData = useCallback( async () => {
        setLoading( true )
        try {
            const { data: { data: { userStats, last12MonthsStats } } } = await api.audit.getDiscussionsStats( { month, showzeroassignmentfaculties: false, institute: selectedInstitute !== "all" ? selectedInstitute : "" } )
            setLast12MonthsStats( Object.keys( last12MonthsStats || {} ).length > 0 ? last12MonthsStats : null )
            setUserStats( userStats )
            setStatsError( null )
        } catch ( err ) {
            setStatsError( { code: err?.response?.status, message: err?.response?.data?.message || "Something went wrong while fetching the assignment audit data." } )
        } finally {
            setLoading( false )
        }
    }, [month, selectedInstitute] )

    useEffect( () => {
        getData()
    }, [getData] )

    return (
        <Box sx={{ flexShrink: 0, display: "flex", flexDirection: "column", gap: layout.cardsGap }}>

            {/* Filter */}
            <AuditPageStatsFilterBar viewToggle={false} showZeroResourcesSwitch={false} resource="discussions" listResourceBtnLabel="View Discussions" title="Discussions statistics" />

            {!loading && <CustomTable
                pageSize={50}
                columns={columns}
                data={userStats}
                tableStyles={{
                    maxHeight: "450px"
                }}
                customActions={[
                    {
                        type: "button",
                        label: "Export",
                        startIcon: Icons.default.Publish,
                        onClick: ( rows ) => exportDiscussionsAuditReport( rows, last12MonthsStats, `${month || "complete"}-${selectedInstitute !== "all" ? selectedInstitute + "-" : ""}-discussions-audit-report` )
                    }
                ]}
            />}
            {/* Retry */}
            {statsError && <TryAgainMessageBlock err={statsError.message} loading={loading} code={statsError.code} getData={statsError.retryFunction} />}


            {loading && <DataLoadingSpinner waitingMessage="Loading exams audit report please..." />}
        </Box >
    )
}

export default DiscussionsStats
